import { ApiError } from '../api/client';

interface ErrorDetail {
  path?: string;
  message?: string;
}

/**
 * Fastify devuelve el detalle de Zod en `details`; para el operador es más útil
 * ver "La contraseña debe incluir un número" que el mensaje genérico.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError && Array.isArray(error.details)) {
    const first = (error.details as ErrorDetail[]).find(
      (detail) => detail && typeof detail.message === 'string' && detail.message.trim(),
    );
    if (first?.message) return first.message;
  }
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}
